<template>
  <div class="navbar-host-button">
    <BaseIconButton
      :icon="nonActiveIcon"
      size="md"
      variant="ghost"
      hoverColor="background-overlay-a10"
      :textColor="isCurrentPageSelected ? 'content-base-inverse-primary' : 'content-base-inverse-secondary'"
      textHoverColor="content-base-inverse-primary"
      @click="$emit('click')"
      v-if="!isActive"
    />
    <BaseIconButton
      :icon="page.activeIcon || page.icon + '-filled'"
      size="md"
      variant="primary"
      bgColor="background-overlay-a10"
      hoverColor="background-overlay-a10"
      textColor="content-base-inverse-primary"
      textHoverColor="content-base-inverse-primary"
      @click="$emit('click')"
      v-else
    />
    <div
      class="notification-icon"
      v-if="page.notification"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    page: Object,
    selectedPage: Object
  },
  computed: {
    isCurrentPageSelected() {
      if (this.page && this.page.constantRoute) return this.$route.name === this.page.constantRoute
      if (!this.page || !this.page.children)
        return this.page.name == this.$route.name || this.page.path === this.$route.path

      return this.page.children.find(ch => ch.name == this.$route.name || ch.path === this.$route.path)
    },
    nonActiveIcon() {
      return this.isCurrentPageSelected ? this.page.activeIcon || this.page.icon + '-filled' : this.page.icon
    },
    isActive() {
      if (this.page.constantRoute) return this.$route.name === this.page.constantRoute
      if (!this.page.children) return false
      if (this.selectedPage) return this.selectedPage == this.page
      return !!this.page.children.find(child => child.name === this.$route.name)
    }
  }
}
</script>

<style scoped>
.navbar-host-button {
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  padding: 6px 12px;
  position: relative;
}

.notification-icon {
  width: 6px;
  height: 6px;
  display: block;
  border-radius: 20px;
  background: var(--qrw-background-error-default);

  position: absolute;
  top: 10px;
  right: 16px;
}
</style>
